export const changeLang = (lang: string) => {
  return {
    type: 'CHANGE_LANG',
    payload: lang,
  }
}

export const setCurrentSearchQuery = (query: string) => {
  return {
    type: 'SET_CURRENT_SEARCH_QUERY',
    payload: query,
  }
}

export const setCurrentSearchFilters = (query: string) => {
  return {
    type: 'SET_CURRENT_SEARCH_FILTERS',
    payload: query,
  }
}

export const setCurrentMainTag = (query: string) => {
  return {
    type: 'SET_CURRENT_MAIN_TAG',
    payload: query,
  }
}

export const setCurrentprofile = (query: string) => {
  return {
    type: 'SET_CURRENT_PROFILE_TAG',
    payload: query,
  }
}

export const setLaboEmptyLabo = (query: string) => {
  return {
    type: 'SET_LABO_EMPTY_LABO',
    payload: query,
  }
}

export const setLaboEmptyOther = (query: string) => {
  return {
    type: 'SET_LABO_EMPTY_OTHER',
    payload: query,
  }
}

export const setProjectsListMap = (query: string) => {
  return {
    type: 'SET_PROJECTS_LIST_MAP',
    payload: query,
  }
}

export const setProjectsStatus = (query: string) => {
  return {
    type: 'SET_PROJECTS_STATUS',
    payload: query,
  }
}

export const setProjectsRegion = (query: string) => {
  return {
    type: 'SET_PROJECTS_REGION',
    payload: query,
  }
}

export const setMapCenter = (query: string) => {
  return {
    type: 'SET_MAP_CENTER',
    payload: query,
  }
}

export const setMapView = (query: string) => {
  return {
    type: 'SET_MAP_VIEW',
    payload: query,
  }
}

export const setCurrentProject = (query: string) => {
  return {
    type: 'SET_CURRENT_PROJECT',
    payload: query,
  }
}

export const setCurrentProjectPoint = (query: string) => {
  return {
    type: 'SET_CURRENT_PROJECT_POINT',
    payload: query,
  }
}

export const setCurrentProjectSheet = (query: string) => {
  return {
    type: 'SET_CURRENT_PROJECT_SHEET',
    payload: query,
  }
}

export const setProjectsInClusters = (query: string) => {
  return {
    type: 'SET_PROJECTS_IN_CLUSTERS',
    payload: query,
  }
}

export const setMap = (query: string) => {
  return {
    type: 'SET_MAP',
    payload: query,
  }
}

export const setMapZoom = (query: string) => {
  return {
    type: 'SET_MAP_ZOOM',
    payload: query,
  }
}

export const setMapAddress = (query: string) => {
  return {
    type: 'SET_MAP_ADDRESS',
    payload: query,
  }
}

export const setMapAddressCoords = (query: string) => {
  return {
    type: 'SET_MAP_ADDRESS_COORDS',
    payload: query,
  }
}

export const setMapAddressFilled = (query: string) => {
  return {
    type: 'SET_MAP_ADDRESS_FILLED',
    payload: query,
  }
}

export const setMapAddressFilledFirstTime = (query: string) => {
  return {
    type: 'SET_MAP_ADDRESS_FILLED_FIRST_TIME',
    payload: query,
  }
}

export const setFiltersChange = (query: string) => {
  return {
    type: 'SET_FILTERS_CHANGE',
    payload: query,
  }
}

export const setFiltersThemesNumber = (query: string) => {
  return {
    type: 'SET_FILTERS_THEMES_NUMBER',
    payload: query,
  }
}

export const setFiltersProfilesNumber = (query: string) => {
  return {
    type: 'SET_FILTERS_PROFILES_NUMBER',
    payload: query,
  }
}

export const setFiltersYearNumber = (query: string) => {
  return {
    type: 'SET_FILTERS_YEAR_NUMBER',
    payload: query,
  }
}

export const setFiltersTypeNumber = (query: string) => {
  return {
    type: 'SET_FILTERS_TYPE_NUMBER',
    payload: query,
  }
}

export const setFiltersHolderNumber = (query: string) => {
  return {
    type: 'SET_FILTERS_HOLDER_NUMBER',
    payload: query,
  }
}

export const setHasFixedProfileNav = (query: boolean) => {
  return {
    type: 'SET_HAS_FIXED_PROFILE_NAV',
    payload: query,
  }
}

export const setHasLaboOpen = (query: boolean) => {
  return {
    type: 'SET_HAS_LABO_OPEN',
    payload: query,
  }
}

export const setHasProfileNavOpen = (query: boolean) => {
  return {
    type: 'SET_HAS_PROFILE_NAV_OPEN',
    payload: query,
  }
}

export const setHasMainNavOpen = (query: boolean) => {
  return {
    type: 'SET_HAS_MAIN_NAV_OPEN',
    payload: query,
  }
}

export const saveSearchState = (query: string) => {
  return {
    type: 'SAVE_SEARCH_STATE',
    payload: query,
  }
}
